import {getUnverifiedToken} from '@sail/data';
import type {StripeContextInput} from '../../../schema/types';
import {API_KEY, ID, TYPE, LIVE_MODE} from './constants';
import type {UnknownUnverifiedToken} from './types';

export default function getUnknownUnverifiedToken(
  id?: NonNullable<StripeContextInput['id']>,
  liveMode?: NonNullable<StripeContextInput['liveMode']>,
  apiKey?: NonNullable<StripeContextInput['apiKey']>,
): UnknownUnverifiedToken {
  return {
    ...getUnverifiedToken(),
    [API_KEY]: apiKey,
    [ID]: id,
    [TYPE]: 'UNKNOWN',
    [LIVE_MODE]: liveMode,
  };
}
